import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-check-in',
	templateUrl: './icon-check-in.component.svg',
})
export class IconCheckInComponent {}
